import { Typography } from "@mui/material";

const ChatPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <Typography
        variant="body1"
        sx={{ marginTop: 2, textAlign: "center" }}
        className="callout"
      >
        Stay tuned for upcoming features!
      </Typography>
    </div>
  );
};

export default ChatPage;
